export * from './tab-settings';
export const PROJECT_CARD_DISPLAY = {
  PANEL: 'panel',
  LIST: 'list'
};
